import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useWeightLog(userId) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;
    fetchLogs();
  }, [userId]); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchLogs() {
    const { data } = await supabase
      .from('weight_logs')
      .select('*')
      .eq('user_id', userId)
      .order('logged_at', { ascending: true });
    if (data) setLogs(data);
  }

  async function addLog(weight) {
    const kg = parseFloat(weight);
    if (!isFinite(kg) || kg < 20 || kg > 400) {
      return { data: null, error: { message: 'Peso fuera de rango (20–400 kg)' } };
    }
    setLoading(true);
    const { data, error } = await supabase
      .from('weight_logs')
      .insert({ user_id: userId, weight: kg })
      .select()
      .single();
    if (!error && data) setLogs(prev => [...prev, data]);
    setLoading(false);
    return { data, error };
  }

  const firstWeight = logs[0]?.weight;
  const lastWeight = logs[logs.length - 1]?.weight;
  const kgLost = firstWeight && lastWeight ? +(firstWeight - lastWeight).toFixed(1) : 0;
  const pctLost = firstWeight ? +((kgLost / firstWeight) * 100).toFixed(1) : 0;

  return { logs, loading, addLog, kgLost, pctLost };
}
